import Swal from "sweetalert2";
import HelperMixin from '../../Shared/HelperMixin.vue';
import PaginationHelper from '../../Shared/PaginationHelper.vue';

export default {
    name: 'Trips',
    mixins: [HelperMixin],
    components: {
        PaginationHelper
    },

    async created() {
        this.loginDetails = await this.CheckLoginStatus();

        if (!this.requireUserType([1])) return;

        this.GetPaymentMethods();
        this.GetInfo(this.pageNo);
    },

    computed: {
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        },

        // Drives the "مسح الفلاتر" button so an operator can always see, and undo,
        // the reason a table looks emptier than they expected.
        hasActiveFilters() {
            return !!(this.Search || this.StatusFilter || this.LevelsFilter ||
                      this.TripTypeFilter || this.PaymentMethodFilter ||
                      this.DateFrom || this.DateTo);
        }
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            Search: '',
            StatusFilter: null,
            LevelsFilter: null,
            DateFrom: null,
            DateTo: null,
            TripTypeFilter: null,
            PaymentMethodFilter: null,
            PaymentMethods: [],

            ScreenTitle: 'الرحلات',
            ScreenTitleSingle: 'رحلة',
            ScreenTitleSingleAl: 'الرحلة',

            Info: [],
            Statistics: [],
            SelectedItem: null,
            ViewDialog: false,
            TripDetails: null,

            // Additional data for trip details tabs
            state: 0, // 0: list, 1: details view
            activeTab: 'details', // details, category, chats, candidates, levels, ratings, passenger
            
            // Trip related data
            TripCategory: null,
            TripChats: [],
            TripDriverCandidates: [],
            TripLevels: [],
            TripRatings: [],
            TripPassenger: null,

            // Assign Driver Form
            assignDriverForm: {
                DriversId: null,
                VehiclesId: null
            },
            AllDrivers: [],
            DriverVehicles: [],

            // البث المباشر (SignalR)
            liveLocation: null,
            hubConnected: false
        };
    },

    methods: {
        applyFilters() {
            this.pageNo = 1;
            this.GetInfo(this.pageNo);
        },

        ClearFilters() {
            this.Search = '';
            this.StatusFilter = null;
            this.LevelsFilter = null;
            this.TripTypeFilter = null;
            this.PaymentMethodFilter = null;
            this.DateFrom = null;
            this.DateTo = null;
            this.applyFilters();
        },

        // The KPI cards are counted from the SAME filtered set the table pages over
        // (see TripsController.Get), so clicking a card can only ever narrow the table
        // down to exactly the rows that card counted.
        FilterByLevel(level) {
            this.LevelsFilter = (this.LevelsFilter === level) ? null : level;
            this.applyFilters();
        },

        GetPaymentMethods() {
            this.$http.GetAllPaymentMethods()
                .then(response => {
                    this.PaymentMethods = (response.data && response.data.info) || [];
                })
                .catch(() => {
                    this.PaymentMethods = [];
                });
        },

        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) {
                this.pageNo = 1;
            }

            if (!this.Search)
                this.$blockUI.Start();

            const dateFrom = this.DateFrom || '';
            const dateTo = this.DateTo || '';
            const status = this.StatusFilter || '';
            const levels = this.LevelsFilter || '';
            const tripType = this.TripTypeFilter || '';
            const paymentMethodId = this.PaymentMethodFilter || '';

            this.$http.GetTrips(this.pageNo, this.pageSize, this.Search, status, levels, dateFrom, dateTo, tripType, paymentMethodId)
                .then(response => {
                    if (!this.Search)
                        this.$blockUI.Stop();

                    this.Info = response.data.info;
                    this.pages = response.data.count;
                    this.Statistics = response.data.statistics;
                })
                .catch(() => {
                    if (!this.Search)
                        this.$blockUI.Stop();
                    this.pages = 0;
                });
        },

        OpenViewDialog(item) {
            this.SelectedItem = item;
            this.ViewDialog = true;
            this.GetTripDetails(item.id);
        },

        ViewInfo(item) {
            this.SelectedItem = item;
            this.state = 1;
            this.activeTab = 'details';
            this.GetTripDetails(item.id);
        },

        GetTripDetails(tripId) {
            this.$blockUI.Start();
            this.$http.GetTripById(tripId)
                .then(response => {
                    this.$blockUI.Stop();
                    this.TripDetails = response.data;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.TripDetails = null;
                });
        },

        CancelTrip(item) {
            Swal.fire({
                title: 'تأكيد إلغاء الرحلة',
                text: 'هل أنت متأكد من إلغاء هذه الرحلة؟',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'نعم، إلغاء الرحلة',
                cancelButtonText: 'إلغاء'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.CancelTrip(item.id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo(this.pageNo);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            let msg = err.response && err.response.data ? err.response.data : 'خطأ';
                            this.$helper.ShowMessage('error', 'خطأ', msg);
                        });
                }
            });
        },

        // Web P0 FIX: advance the trip state from the dashboard.
        // newStatus: 3=وصل السائق, 4=بدأت الرحلة, 5=مكتملة. The backend enforces
        // the strict Accepted→Arrived→Started→Completed sequence.
        SetTripState(item, newStatus) {
            const labels = { 3: 'تسجيل وصول السائق', 4: 'بدء الرحلة', 5: 'إنهاء الرحلة' };
            const label = labels[newStatus] || 'تحديث الحالة';
            Swal.fire({
                title: label,
                text: `هل أنت متأكد من "${label}" لهذه الرحلة؟`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'نعم',
                cancelButtonText: 'إلغاء'
            }).then((result) => {
                if (!result.isConfirmed) return;
                this.$blockUI.Start();
                this.$http.SetTripState(item.id, newStatus)
                    .then((response) => {
                        this.$blockUI.Stop();
                        const msg = response.data && response.data.message ? response.data.message : 'تم تحديث حالة الرحلة بنجاح.';
                        this.$helper.ShowMessage('success', 'عملية ناجحة', msg);
                        if (this.state === 1) {
                            this.GetTripDetails(item.id);
                        } else {
                            this.GetInfo(this.pageNo);
                        }
                    })
                    .catch((err) => {
                        this.$blockUI.Stop();
                        let m = err.response && err.response.data ? err.response.data : 'تعذر تحديث حالة الرحلة';
                        this.$helper.ShowMessage('error', 'خطأ', m);
                    });
            });
        },

        getTripTypeText(type) {
            // LE-033: match Domain.TripType (Regular=1 → "عادية", not "مجدولة"); add نسائي=5.
            // 6 = رحلة تعاقدية (contract trips) — generated by the contract engine,
            // visible here so admins can see every trip in one list.
            const types = {
                1: 'عادية',
                2: 'مشتركة',
                3: 'مدرسية',
                5: 'نسائي',
                6: 'رحلة تعاقدية'
            };
            return types[type] || 'غير معروف';
        },

        getTripTypeClass(type) {
            const classes = {
                1: 'bg-primary-subtle text-primary',
                2: 'bg-info-subtle text-info',
                3: 'bg-warning-subtle text-warning',
                5: 'bg-danger-subtle text-danger',
                6: 'bg-success-subtle text-success'
            };
            return classes[type] || 'bg-secondary-subtle text-secondary';
        },

        getLevelText(level) {
            // LE-034: include DriverOffered=11 (Domain.TripLevel) so the offer phase
            // isn't shown as "غير معروف".
            // 7/8 are per-rider rows the shared/contract flow writes into TripsLevels
            // (صعود/إنزال راكب). They are never a Trip.Levels value, but they DO show
            // up in the timeline tab, where they used to render as "غير معروف".
            const levels = {
                1: 'قيد الانتظار',
                2: 'تم القبول',
                3: 'وصل السائق',
                4: 'بدأت الرحلة',
                5: 'مكتملة',
                6: 'ملغاة',
                7: 'صعود راكب',
                8: 'إنزال راكب',
                11: 'عرض على السائق'
            };
            return levels[level] || 'غير معروف';
        },

        getLevelClass(level) {
            const classes = {
                1: 'bg-warning-subtle text-warning',
                2: 'bg-info-subtle text-info',
                3: 'bg-primary-subtle text-primary',
                4: 'bg-primary-subtle text-primary',
                5: 'bg-success-subtle text-success',
                6: 'bg-danger-subtle text-danger',
                7: 'bg-info-subtle text-info',
                8: 'bg-info-subtle text-info',
                11: 'bg-warning-subtle text-warning'
            };
            return classes[level] || 'bg-secondary-subtle text-secondary';
        },

        // Coloured dot for the vertical timeline in the "سجل المراحل" tab.
        getLevelDotClass(level) {
            const classes = {
                1: 'bg-warning',
                2: 'bg-info',
                3: 'bg-primary',
                4: 'bg-primary',
                5: 'bg-success',
                6: 'bg-danger',
                7: 'bg-info',
                8: 'bg-info',
                11: 'bg-warning'
            };
            return classes[level] || 'bg-secondary';
        },

        getPaymentText(item) {
            if (!item) return '-';
            return item.paymentMethodName || 'غير محدد';
        },

        getStatusText(status) {
            return status === 1 ? 'نشط' : 'غير نشط';
        },

        getStatusClass(status) {
            return status === 1 ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger';
        },



        onPageSizeChanged(size) {
            this.pageSize = size;
            this.pageNo = 1;
            this.GetInfo();
        },

        BackToList() {
            this.state = 0;
            this.SelectedItem = null;
            this.TripDetails = null;
            this.activeTab = 'details';
            this.GetInfo(this.pageNo);
        },

        // Switch between tabs
        switchTab(tab) {
            this.activeTab = tab;
            
            if (!this.SelectedItem) return;

            switch(tab) {
                case 'category':
                    this.GetTripCategory(this.SelectedItem.id);
                    break;
                case 'chats':
                    this.GetTripChats(this.SelectedItem.id);
                    break;
                case 'candidates':
                    this.GetTripDriverCandidates(this.SelectedItem.id);
                    break;
                case 'levels':
                    this.GetTripLevels(this.SelectedItem.id);
                    break;
                case 'ratings':
                    this.GetTripRatings(this.SelectedItem.id);
                    break;
                case 'passenger':
                    this.GetTripPassenger(this.SelectedItem.id);
                    break;
            }
        },

        // Get Trip Category
        GetTripCategory(tripId) {
            this.$blockUI.Start();
            this.$http.GetTripCategory(tripId)
                .then(response => {
                    this.$blockUI.Stop();
                    this.TripCategory = response.data.info;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.TripCategory = null;
                });
        },

        // Get Trip Chats
        GetTripChats(tripId) {
            this.$blockUI.Start();
            this.$http.GetTripChats(tripId)
                .then(response => {
                    this.$blockUI.Stop();
                    this.TripChats = response.data.info || [];
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.TripChats = [];
                });
        },

        // Get Trip Driver Candidates
        GetTripDriverCandidates(tripId) {
            this.$blockUI.Start();
            this.$http.GetTripDriverCandidates(tripId)
                .then(response => {
                    this.$blockUI.Stop();
                    this.TripDriverCandidates = response.data.info || [];
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.TripDriverCandidates = [];
                });
        },

        // Get Trip Levels History
        GetTripLevels(tripId) {
            this.$blockUI.Start();
            this.$http.GetTripLevels(tripId)
                .then(response => {
                    this.$blockUI.Stop();
                    this.TripLevels = response.data.info || [];
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.TripLevels = [];
                });
        },

        // Get Trip Ratings
        GetTripRatings(tripId) {
            this.$blockUI.Start();
            this.$http.GetTripRatings(tripId)
                .then(response => {
                    this.$blockUI.Stop();
                    this.TripRatings = response.data.info || [];
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.TripRatings = [];
                });
        },

        // Get Trip Passenger
        GetTripPassenger(tripId) {
            this.$blockUI.Start();
            this.$http.GetTripPassenger(tripId)
                .then(response => {
                    this.$blockUI.Stop();
                    this.TripPassenger = response.data.info;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.TripPassenger = null;
                });
        },

        // Open Assign Driver Modal
        OpenAssignDriverModal(item) {
            this.SelectedItem = item;
            this.assignDriverForm = {
                DriversId: null,
                VehiclesId: null
            };
            this.GetAllDrivers();
        },

        // Get All Drivers
        GetAllDrivers() {
            this.$blockUI.Start();
            this.$http.GetAllDrivers()
                .then(response => {
                    this.$blockUI.Stop();
                    this.AllDrivers = response.data.info || [];
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.AllDrivers = [];
                });
        },

        // On Driver Selection - Load their vehicles
        onDriverChange() {
            this.assignDriverForm.VehiclesId = null;
            this.DriverVehicles = [];
            
            if (this.assignDriverForm.DriversId) {
                this.GetDriverVehicles(this.assignDriverForm.DriversId);
            }
        },

        // Get Driver Vehicles
        GetDriverVehicles(driverId) {
            this.$blockUI.Start();
            this.$http.GetDriverVehicles(driverId)
                .then(response => {
                    this.$blockUI.Stop();
                    this.DriverVehicles = response.data.info || [];
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.DriverVehicles = [];
                });
        },

        // Submit Assign Driver
        submitAssignDriver() {
            const form = document.getElementById('assignDriverForm');

            if (!form.checkValidity()) {
                form.classList.add('was-validated');
                this.$helper.ShowMessage('warning', 'تنبيه', 'يرجى اختيار السائق');
                return;
            }

            form.classList.remove('was-validated');

            if (!this.SelectedItem || !this.assignDriverForm.DriversId) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'يرجى اختيار السائق');
                return;
            }

            this.$blockUI.Start();

            this.$http.AssignDriverToTrip(this.SelectedItem.id, this.assignDriverForm)
                .then(response => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                    this.$helper.DestroyElemntById('CloseAssignDriver');
                    
                    // Refresh data
                    if (this.state === 1) {
                        this.GetTripDetails(this.SelectedItem.id);
                    } else {
                        this.GetInfo(this.pageNo);
                    }
                })
                .catch(err => {
                    this.$blockUI.Stop();
                    let msg = err.response && err.response.data ? err.response.data : 'فشل تعيين السائق';
                    this.$helper.ShowMessage('error', 'خطأ', msg);
                });
        }
    }
}
